import SendBird from 'sendbird';
import type { InboxItem } from '.';

const getChannelTimestamp = (channel: SendBird.GroupChannel) => {
  const lastMessage = channel.lastMessage;
  return lastMessage ? lastMessage.createdAt : channel.createdAt;
};

export const sortInboxItems = (items: InboxItem[]) => {
  return [...items].sort(
    (a, b) => getChannelTimestamp(b.channel) - getChannelTimestamp(a.channel)
  );
};
